import React, { useState } from "react";
import Text from "./Text";
import TIcon from "./TIcon";
const ChapterToggler = ({ children = null, toggleKey = null, title = null }) => {
    const [isExpanded, setIsExpanded] = useState(
        toggleKey && localStorage.getItem(toggleKey) === 'true'
    );

    const toggleExpanded = () => {
        const newState = !isExpanded;
        if(toggleKey){
            localStorage.setItem(toggleKey, newState);
        }
        setIsExpanded(newState);
    }
    return (
        <>
            <div className="flex items-center justify-center mt-4 mb-2 cursor-pointer"
                onClick={toggleExpanded}
            >
                <Text type="main" classNames="text-center">{title}</Text>
                <TIcon name={isExpanded ? 'chevron-down' : 'chevron-up'} classNames="ml-2" />
            </div>
            <div className={`flex flex-col gap-4 p-6 ${isExpanded ? '' : 'hidden'}`}>
                {children}
            </div>
        </>
    )
}
export default ChapterToggler